var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.104,
    height: 143,
    viewBox: "0 0 149.104 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35 -38.2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1963",
    d: "M169.835 126.408c-11.7 3.362-30.893 24.909-42.591 28.271s-27.464-1.815-27.464-1.815 16.606-1.614 25.716-4.2 10.824-6.454 9.614-10.69c-2.925-10.253-20.808-6.858-29.985-5.647-10.018-2.319-15.6-4.841-30.288-1.95a13.6 13.6 0 0 1 .269 2.622l.134 44.844c15.06 2.252 40.743 5.244 52.811 1.782 17.581-5.042 57.685-41.919 56-47.768s-8.368-7.13-14.216-5.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 154",
    cx: 41.516,
    cy: 41.516,
    r: 41.516,
    transform: "translate(39 38.2)",
    fill: "#39beec"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 155",
    cx: 41.516,
    cy: 41.516,
    r: 41.516,
    transform: "translate(94.198 38.2)",
    fill: "#1b60a3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 742",
    fill: "#fff",
    d: "M35 127.551h34.961v52.777H35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/Rewards.c1c6bde984d4a13f9fa8362dc6cd5e0b.svg";
export { ForwardRef as ReactComponent };